import React from 'react';
import PropTypes from 'prop-types';
import Navbar from 'components/navbar/Navbar';
import navbarStore from 'components/navbar/NavbarStore';
import HeroImageUrl from 'assets/images/hotels_hero.jpg';

const HeroImageStyle = {
  backgroundImage: `url(${HeroImageUrl})`
};

function HotelsHero({children, translations}) {
  const {headline, description} = translations;
  return (
    <section className="hotels-hero bg-cover" style={HeroImageStyle}>
      <div className="bg-overlay"/>
      <div className="d-flex flex-column">
        <header className="mb-auto">
          <Navbar navbar={navbarStore} />
        </header>
        <div className="w-lg-1-2 mx-auto position-relative text-center text-white">
          <h1 className="display-2 mt-4">
            {headline}
          </h1>
          <p className="text-lead opacity-mid d-none d-sm-block" dangerouslySetInnerHTML={{__html: description}}>
          </p>
        </div>
        {children}
      </div>
    </section>
  );
}

HotelsHero.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.node
  ]),
  translations: PropTypes.shape({
    headline: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired
  })
};

export default HotelsHero;
